
import React from "react";
import { getSEOData } from "../../../../global/utils/constants/seoConfig";
import SEO from "../../../../global/components/SEO/SEO";
import DirectoryContent from "../Components/DirectoryContent";

const Directory = () => {
  const seoData = getSEOData("/directory");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <DirectoryContent />
    </>
  );
};

export default Directory;
